import {createRouter as createTanStackRouter} from '@tanstack/react-router';
import {routeTree} from './routeTree.gen';
import type {Profile} from '@/apiTypes/profile';
import {FLAG_DEFAULTS, type FeatureFlags} from '@/apiTypes/featureFlags';

export interface RouterContext {
  profile: Profile | null;
  featureFlags: FeatureFlags;
}

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,
    context: {
      profile: null,
      featureFlags: FLAG_DEFAULTS,
    },
    scrollRestoration: true,
  });

  return router;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
